import { lazy } from 'react';

// project import
import GuestGuard from 'utils/route-guard/GuestGuard';
import CommonLayout from 'layout/CommonLayout';
import Loadable from 'components/Loadable';

// render - login
const AuthLogin = Loadable(lazy(() => import('pages/auth/login')));
const AuthAcceptInvite = Loadable(lazy(() => import('pages/auth/accept-invite')));
// const AuthRegister = Loadable(lazy(() => import('pages/auth/register')));
const AuthForgotPassword = Loadable(lazy(() => import('pages/auth/forgot-password')));
const AuthCheckMail = Loadable(lazy(() => import('pages/auth/check-mail')));
const AuthResetPassword = Loadable(lazy(() => import('pages/auth/reset-password')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: (
        <GuestGuard>
          <CommonLayout />
        </GuestGuard>
      ),
      children: [
        {
          path: '*',
          element: <AuthLogin />
        },
        {
          path: '/',
          element: <AuthLogin />
        },
        {
          path: 'login',
          element: <AuthLogin />
        },
        {
          path: 'invite-authentication/:user_id/:token',
          element: <AuthAcceptInvite />
        },
        {
          path: 'reset-password',
          element: <AuthResetPassword />
        },
        {
          path: 'website',
          element: <WebsiteRedirect />
        },
        {
          path: 'forgot-password',
          element: <AuthForgotPassword />
        },
        {
          path: 'check-mail',
          element: <AuthCheckMail />
        },
        {
          path: 'reset-password/:user_id/:token',
          element: <AuthResetPassword />
        }
      ]
    }
  ]
};

function WebsiteRedirect() {
  window.location.href = 'https://opnbuildings.com/';
  return null;
}

export default LoginRoutes;
